import React, { Component } from 'react'
import './Contact.scss'
import { Icon } from 'semantic-ui-react';


export default class Contact extends Component {
    render() {
        return (
            <div id="contact2">
      <div className="row">
                <div className="col-md-3 col-sm-6 col-lg-3">
                    <div className="contact1">
                    <Icon className="App-logo" name='car' />
                        <h2>Mobilité</h2>
                        <p>Toulon</p>
                    </div>
                </div>
                <div className="col-md-3 col-sm-6 col-lg-3">
                    <div className="contact1">
                    <Icon className="App-logo" name='phone' />
                        <h2>Téléphone</h2>
                        <p>06.60.12.00.12</p>
                    </div>
                </div>
                <div className="col-md-3 col-sm-6 col-lg-3">
                    <div className="contact1">
                    <Icon className="App-logo" name='mail' />
                        <h2>Email</h2>
                        <p>alex.plomberie83@gmail.com</p>
                    </div>
                </div>
                <div className="col-md-3 col-sm-6 col-lg-3">
                    <div className="contact1">
                    <Icon className="App-logo" name='gg' />
                        <h2>Réseaux sociaux</h2>
                        <p className="socials">
                            <a href="https://www.linkedin.com/in/alex-provost/" target={'_blank'}><Icon className="logoSocials" name='linkedin' /></a> 
                            <a href="https://github.com/alexlucas83" target={'_blank'}><Icon className="logoSocials1" name='github' /></a> 
                        </p>
                    </div>
                </div>
            </div>
            </div>
        )
    }
}
